// djb:dry-very similar to StaggeredPackageBuilderModel
import { PackageBuilderSummary } from './package-builder-summary.model';

export class StaggeredPackageBuilderSummary {
  front: PackageBuilderSummary;
  rear: PackageBuilderSummary;

  constructor () {
    this.front = new PackageBuilderSummary;
    this.rear = new PackageBuilderSummary;
  }
}
